import css from './index.module.scss';
import EfImg from '@elem/ui/ef-img';
import { useLang } from '@/i18n';
import { useEffect, useState } from 'react';

type ItemType = {
    img: string;
    title: string;
    text: string;
};
export default function Modal1({ type, callback }: any) {
    const { t } = useLang('Oasis');
    const [open, setIsOpen] = useState(false);
    const items: ItemType[] = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1735785135826/M1.png',
            title: t('C_modal1_item1_title'),
            text: t('C_modal1_item1_desc'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1735640114967/M2.png',
            title: t('C_modal1_item2_title'),
            text: t('C_modal1_item2_desc'),
        },
    ];

    const handleClose = () => {
        setIsOpen(false);
        setTimeout(() => {
            callback();
        }, 1000);
    };

    useEffect(() => {
        setIsOpen(type === 1);
    }, [type]);

    return (
        <div className={`modal ${css.modal} ${open ? 'open' : 'close'}`}>
            <div className="content">
                <svg className="close" onClick={handleClose} xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
                    <g clipPath="url(#clip0_1297_95200)">
                        <path
                            d="M28 49C39.598 49 49 39.598 49 28C49 16.402 39.598 7 28 7C16.402 7 7 16.402 7 28C7 39.598 16.402 49 28 49Z"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M28 49C39.598 49 49 39.598 49 28C49 16.402 39.598 7 28 7C16.402 7 7 16.402 7 28C7 39.598 16.402 49 28 49Z"
                            stroke="#ccc"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path d="M35 21L21 35" stroke="#ccc" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M21 21L35 35" stroke="#ccc" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_1297_95200">
                            <rect width="56" height="56" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
                <ul className="items">
                    {items?.map((item: ItemType, k: number) => (
                        <li className="item" key={k}>
                            <div className="item-img">
                                <EfImg pc={item.img} />
                            </div>
                            <p className="item-title">{item.title}</p>
                            <p className="item-text">{item.text}</p>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
